import { StepForm } from '@iq-firebolt/client'
import fireboltBlueberry from '@iq-firebolt/blueberry-theme'

import useStepTemplate from 'hooks/useStepTemplate'
import useHasImageError from 'hooks/useHasImageError'

import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'
import ModalOneButton from 'components/common/ModalOneButton'

import { UploadField } from '../../components/UploadField'

import { useHandlers } from './hooks/handlers'
import { useConditionals } from './hooks/conditionals'

import { FormTitle } from 'components/common/FormTitle'
import { Conditional } from 'iq-blueberry'
import { textStep } from './data'

const UploadStep = ({ fireboltStep, ...stepProps }) => {
  const imageErrorsFound = useHasImageError()
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
  })

  const { modalErrorButtonText, modalErrorHasCloseButton } = useConditionals()

  const {
    modalErrorOpen,
    closeModalClicked,
    handleChangeFields,
    handleImageErrors,
  } = useHandlers({ imageErrorsFound })

  handleImageErrors(imageErrorsFound)

  return (
    <>
      <FormContainer
        imageSrc={
          textStep[fireboltStep?.slug]
            ? textStep[fireboltStep?.slug]?.image
            : textStep['default'].image
        }>
        <div className="bbourocard-upload">
          <Conditional
            condition={textStep[fireboltStep?.slug]}
            renderIf={
              <FormTitle
                title={textStep[fireboltStep?.slug]?.title}
                description={textStep[fireboltStep?.slug]?.description}
                hasRequiredFieldWarning
              />
            }
            renderElse={
              <FormTitle
                title={textStep['default'].title}
                description={textStep['default'].description}
                hasRequiredFieldWarning
              />
            }
          />

          <StepForm
            onChangeField={handleChangeFields}
            theme={{
              ...fireboltBlueberry,
              'Upload': (props) => <UploadField {...stepProps} {...props} />,
            }}
            customActionsChild={({ formData }) => (
              <ActionButtons
                formData={formData}
                onGoBack={handleGoBackform}
                beforeSubmitStep={runBeforeChangeStep}
              />
            )}></StepForm>
        </div>
      </FormContainer>
      <ModalOneButton
        title="Precisamos que você envie uma nova foto"
        text="Infelizmente, não conseguimos processar a imagem enviada. Para continuar, precisamos que você tire uma nova foto."
        isActive={modalErrorOpen}
        handleButton={closeModalClicked}
        handleCloseModal={closeModalClicked}
        buttonText={modalErrorButtonText}
        hasOverlay={true}
        hasCloseButton={modalErrorHasCloseButton}
      />
    </>
  )
}

export default UploadStep
